export default __webpack_public_path__ + "static/media/bitfrost.9fa074ed.png";